import React, { useEffect, useState } from 'react'
import { Image, View } from 'react-native'

import Text from '@common/components/Text'
import { SPACING_MI } from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'

const LOGO_SIZE = 16

/**
 * The aggregator behind a route: its logo (when the provider sends one — ZKX
 * Trade's `providerLogoUri`) followed by its name. A logo that fails to load is
 * dropped rather than replaced with a generic placeholder, so the name alone
 * still reads correctly.
 */
const RouteProviderBadge = ({ name, logoUri }: { name: string; logoUri?: string }) => {
  const [hasLogoFailed, setHasLogoFailed] = useState(false)

  useEffect(() => {
    setHasLogoFailed(false)
  }, [logoUri])

  return (
    <View style={[flexbox.directionRow, flexbox.alignCenter]}>
      {!!logoUri && !hasLogoFailed && (
        <Image
          source={{ uri: logoUri }}
          style={{
            width: LOGO_SIZE,
            height: LOGO_SIZE,
            borderRadius: LOGO_SIZE / 2,
            marginRight: SPACING_MI
          }}
          onError={() => setHasLogoFailed(true)}
          accessibilityLabel={name}
        />
      )}
      <Text fontSize={12} weight="semiBold" appearance="secondaryText" numberOfLines={1}>
        {name}
      </Text>
    </View>
  )
}

export default React.memo(RouteProviderBadge)
